<template>
  <div
    v-bind:class="[displayMode == 0 ?
    'percentage_chart_base_container summary_grid item_container_margin' :
    '']">
    <div v-if="displayMode == 0" class="summary_top">
      <div class="summary_text summary_text_weight_700">{{ titleText }}</div>
    </div>
    <div v-else>
      <div class="summary_text summary_text_weight_700">{{ titleText }}</div>
    </div>
    <div v-if="recycleTotal > 0 || wasteTotal > 0">
      <div class="bottom_container_total_chart">
        <div
          v-bind:class="[displayMode == 0 ? 'total_chart_value_text total_chart_value_text_margin' : 'total_chart_value_text']"
          :style="{ 'color': getPrimaryColor() }"
        >
          {{ recyclePercentage }}%
        </div>
        <div class="explain_text">
          (再資源 / 廃棄物)
        </div>
        <div
          class="bar_chart_container"
          :style="{ 'background-color': getSecondaryColor() }">
          <div
            v-bind:class="[recyclePercentage > 99 ? 'chart_percentage_bar_100_percent' : 'chart_percentage_bar']"
            :style="{ 'width': recyclePercentage+'%', 'background-color': getPrimaryColor() }">
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height: 220px">
      <DataNotFound/>
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import DataNotFound from '../common/DataNotFound'

export default {
  name: 'RecyclePercentageChart',
  components: { DataNotFound },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    titleText: {
      type: String,
      default: ''
    },
    colorSet: {
      type: Number,
      default: 0
    },
    displayMode: {
      type: Number,
      default: 0
    }
  },
  mixins: [utils],
  watch: {
    receivedData: function() {
      this.refreshChart()
    },
    titleText: function() {

    },
    colorSet: function() {

    }
  },
  data() {
    return {
      recyclePercentage: 31,
      recycleTotal: 0,
      wasteTotal: 0,
    }
  },
  mounted() {

  },
  methods: {
    refreshChart() {
      this.recycleTotal = 0
      this.wasteTotal = 0
      for(var item in this.receivedData) {
        if(item == "Incineration" || item == "Landfill") {
          this.wasteTotal += this.getTotal(this.receivedData[item])
        } else {
          this.recycleTotal += this.getTotal(this.receivedData[item])
        }
      }
      this.recyclePercentage = new Number((this.recycleTotal / (this.recycleTotal + this.wasteTotal) * 100)).toFixed(0)
    },
    getTotal(jsonObject) {
      if(jsonObject == null) {
        return 0
      }
      let total = 0
      for (var item in jsonObject) {
        total += jsonObject[item] / 1000 // gram to kg
      }
      return total
    },
    getPrimaryColor() {
      if(this.colorSet == 0) {
        return '#00687F'
      }
      return '#20821B'
      
    },
    getSecondaryColor() {
      if(this.colorSet == 0) {
        return '#AEE0E8'
      }
      return '#BBE9BA'
    }
  }
}
</script>

<style scoped>
.bottom_container_total_chart {
  padding: 15px 15px;
  text-align: center;
}

.total_chart_value_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: #005061;
}

.total_chart_value_text_margin {
  margin-top: 30px;
}

.explain_text {
  font-family: 'SF Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #343A3F;
  margin-top: 8px;
}

.total_chart_graph {
  border-radius: 8px;
  display: grid;
  grid-template-rows: 2fr 4fr 1fr;
  box-sizing: border-box;
}

.percentage_chart_base_container {
  width: 1408px;
  height: 316px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.19), 0 2px 2px rgba(0, 0, 0, 0.23);
  border-radius: 12px;
  margin-bottom: 10px;
  background-color: #ffffff;
}

.summary_grid {
  display: grid;
  grid-template-rows: 1fr 4fr;
  align-content: center;
}

.item_container_margin {
  margin-left: auto;
  margin-right: auto;
}

.summary_top {
  display: grid;
  padding: 15px 15px;
  grid-template-columns: 1fr 1fr;
  border-bottom: solid 1px rgba(52, 58, 63, 0.1);
}

.summary_text {
  justify-content: center;
  flex-direction: column;
  display: flex;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.15px;

  /* Forms/Normal */
  color: #333333;
}

.summary_text_weight_700 {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.15px;
}

.summary_menu_container {
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: end;
}

.width_auto {
  width: auto;
}

.bar_chart_container {
  width: 100%;
  height: 44px;
  display: inline-flex;
  box-sizing: border-box;
  margin-top: 30px;
  border-radius: 8px;
}

.chart_percentage_bar {
  border-radius: 8px 0px 0px 8px;
  transform: matrix(1, 0, 0, -1, 0, 0);
}

.chart_percentage_bar_100_percent {
  border-radius: 8px;
  transform: matrix(1, 0, 0, -1, 0, 0);
}

</style>
